import React, { useMemo } from 'react'
import cn from 'classnames'

import { SelectButtonField } from '@components/forms/SelectButtonField'
import { SortField } from '@components/forms/SortField'
import { RecommendTypeSearchEnum } from '@interfaces/RecommendTypeSearchEnum'
import { OrderedKeyEnum } from '@interfaces/OrderedEnum'
import { PrimaryTypeEnum } from '@interfaces/PrimaryTypeEnum'
import { SortEnum } from '@interfaces/SortEnum'
import { useTheme } from '@hooks/contexts/ThemeContext/ThemeContext'

const defaultTypeOptions = [
  // { value: RecommendTypeSearchEnum.WHOLE, text: 'ตอนเดียว' },
  // { value: RecommendTypeSearchEnum.CHAPTER, text: 'มีมากกว่า 1 ตอน' },
  { value: RecommendTypeSearchEnum.ENDED, text: 'จบแล้ว' },
  { value: RecommendTypeSearchEnum.NOT_END, text: 'ยังไม่จบ' },
]

const FormSection = ({
  isEbook,
  recommendationSearch,
}: {
  isEbook: boolean
  recommendationSearch: PrimaryTypeEnum
}) => {
  const { isNightOrDarkTheme } = useTheme()
  const isEndedOrTopChart = [
    PrimaryTypeEnum.ENDED,
    PrimaryTypeEnum.TOP_CHART,
  ].includes(recommendationSearch)

  const typeOptions = useMemo(() => {
    let options = defaultTypeOptions
    if (isEbook || isEndedOrTopChart) {
      options = defaultTypeOptions.filter(o =>
        [
          RecommendTypeSearchEnum.CHAPTER,
          RecommendTypeSearchEnum.WHOLE,
        ].includes(o.value)
      )
    }
    return options
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEbook, recommendationSearch, isEndedOrTopChart])

  const orderedOptions = useMemo(() => {
    if (recommendationSearch === PrimaryTypeEnum.HOT_NEW) {
      return [
        {
          value: `${OrderedKeyEnum.POPULAR}:${SortEnum.DESC}`,
          title: 'ความนิยม',
          label: 'มาก-น้อย',
        },
      ]
    }
    if (
      [PrimaryTypeEnum.NEW, PrimaryTypeEnum.ENDED].includes(
        recommendationSearch
      )
    ) {
      return [
        {
          value: `${OrderedKeyEnum.UPDATED_AT}:${SortEnum.DESC}`,
          title: 'วันอัปเดต',
          label: 'ใหม่-เก่า',
        },

        {
          value: `${OrderedKeyEnum.POPULAR}:${SortEnum.DESC}`,
          title: 'ความนิยม',
          label: 'มาก-น้อย',
        },
      ]
    }
    return [
      {
        value: `${OrderedKeyEnum.PURCHASED}:${SortEnum.DESC}`,
        title: 'เรื่องฮิตขายดี',
        label: 'มาก-น้อย ',
      },
      {
        value: `${OrderedKeyEnum.POPULAR}:${SortEnum.DESC}`,
        title: 'ความนิยม',
        label: 'มาก-น้อย',
      },
    ]
  }, [recommendationSearch])

  return (
    <>
      <SortField
        name='ordered'
        classNameSelect='w-[400px] mobile:w-full'
        options={orderedOptions}
        isShowLabel
        className='mobile:w-full'
      />
      <div className='flex-1'>
        {!isEndedOrTopChart && (
          <SelectButtonField
            name='recommendTypeSearch'
            options={typeOptions}
            mode='line'
            label='ประเภท'
            className={cn('w-fit !bg-white', {
              '!bg-transparent': isNightOrDarkTheme,
            })}
          />
        )}
      </div>
    </>
  )
}

export default FormSection
